import { render, staticRenderFns } from "./PanelCompetitionMessagesMail.vue?vue&type=template&id=31e296ea&scoped=true&"
import script from "./PanelCompetitionMessagesMail.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionMessagesMail.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionMessagesMail.vue?vue&type=style&index=0&id=31e296ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e296ea",
  null
  
)

export default component.exports